import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
	createStyles({
		container: {
			display: "flex",
			alignItems: "center",
		},
		border: {
			borderBottom: `1px solid ${theme.palette.tableDivider.main}`,
			width: "100%",
		},
		borderDangerColor: {
			borderBottom: `1px solid ${theme.palette.error.main}`,
		},
		content: {
			padding: "0 10px 0 10px",
			fontWeight: 400,
			fontSize: "12px",
			color: theme.palette.text.secondary,
			whiteSpace: "nowrap",
		},
		borderContent: { border: `1px solid ${theme.palette.tableDivider.main}`, borderRadius: "20px", objectFit: "contain" },
	})
);
